var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mh-middle"},[_c('div',{staticClass:"mh-middle-inner"},[_c('ContentTitle',{attrs:{"title":"Time Clock"}}),_c('TimeClock',{attrs:{"records":_vm.timeClockShifts},on:{"save-clockin-form":_vm.getShifts,"save-clockout-form":_vm.getShifts}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }